import React from "react";
import moment from "moment-jalaali";
import {
  convertUnixToPersianDate,
  getPersianDateObj,
} from "../../../constant/helper";

function MessageDateCategories(props) {
  let currentlyTime;
  let nowYear = moment().jYear();

  const handleCompareDate = () => {
    if (props.currentlyItem && props.currentlyItem.time) {
      if (props.index === 0) {
        currentlyTime = moment.unix(props.currentlyItem.time / 1000);
        return true;
      } else {
        currentlyTime = moment.unix(props.currentlyItem.time / 1000);
        let previousDate =
          props.index === 0
            ? props.messagesList[props.index].time
            : props.messagesList[props.index - 1].time;
        let start = convertUnixToPersianDate(
          props.currentlyItem.time,
          "jYYYY-jMM-jDD"
        );
        let end = convertUnixToPersianDate(previousDate, "jYYYY-jMM-jDD");
        if (start < end || start > end) {
          return true;
        } else {
          return false;
        }
      }
    } else if (props.currentlyItem && props.currentlyItem.createdDateMilli) {
      if (props.index === 0) {
        currentlyTime = moment.unix(
          props.currentlyItem.createdDateMilli / 1000
        );
        return true;
      } else {
        currentlyTime = moment.unix(
          props.currentlyItem.createdDateMilli / 1000
        );
        let previousDate =
          props.index === 0
            ? props.messagesList[props.index].createdDateMilli
            : props.messagesList[props.index - 1].createdDateMilli;
        let start = convertUnixToPersianDate(
          props.currentlyItem.createdDateMilli,
          "jYYYY-jMM-jDD"
        );
        let end = convertUnixToPersianDate(previousDate, "jYYYY-jMM-jDD");
        if (start < end || start > end) {
          return true;
        } else {
          return false;
        }
      }
    } else if (props.currentlyItem && props.currentlyItem.createdAt) {
      if (props.index === 0) {
        currentlyTime = moment.unix(props.currentlyItem.createdAt / 1000);
        return true;
      } else {
        currentlyTime = moment.unix(props.currentlyItem.createdAt / 1000);
        let previousDate =
          props.index === 0
            ? props.messagesList[props.index].createdAt
            : props.messagesList[props.index - 1].createdAt;
        let start = convertUnixToPersianDate(
          props.currentlyItem.createdAt,
          "jYYYY-jMM-jDD"
        );
        let end = convertUnixToPersianDate(previousDate, "jYYYY-jMM-jDD");
        if (start < end || start > end) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const handleCompareYear = () => {
    if (props.currentlyItem && props.currentlyItem.time) {
      currentlyTime = moment.unix(props.currentlyItem.time / 1000);
      let previousDate =
        props.index === 0
          ? props.messagesList[props.index].time
          : props.messagesList[props.index - 1].time;
      let startYear = moment.unix(props.currentlyItem.time / 1000).jYear();
      let endYear = moment.unix(previousDate / 1000).jYear();
      if (startYear !== nowYear) {
        return true;
      } else if (startYear !== endYear) {
        return true;
      } else {
        return false;
      }
    } else if (props.currentlyItem && props.currentlyItem.createdDateMilli) {
      currentlyTime = moment.unix(props.currentlyItem.createdDateMilli / 1000);
      let previousDate =
        props.index === 0
          ? props.messagesList[props.index].createdDateMilli
          : props.messagesList[props.index - 1].createdDateMilli;
      let startYear = moment.unix(
        props.currentlyItem.createdDateMilli / 1000
      ).jYear;
      let endYear = moment.unix(previousDate / 1000).jYear;
      if (startYear !== nowYear) {
        return true;
      } else if (startYear !== endYear) {
        return true;
      } else {
        return false;
      }
    } else if (props.currentlyItem && props.currentlyItem.createdAt) {
      currentlyTime = moment.unix(props.currentlyItem.createdAt / 1000);
      let previousDate =
        props.index === 0
          ? props.messagesList[props.index].createdAt
          : props.messagesList[props.index - 1].createdAt;
      let startYear = moment.unix(props.currentlyItem.createdAt / 1000).jYear();
      let endYear = moment.unix(previousDate / 1000).jYear();
      if (startYear !== nowYear) {
        return true;
      } else if (startYear !== endYear) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div style={props.className}>
      {handleCompareYear()
        ? `${getPersianDateObj(currentlyTime).day} ${
            getPersianDateObj(currentlyTime).monthName
          }، ${getPersianDateObj(currentlyTime).year}`
        : handleCompareDate()
        ? `${getPersianDateObj(currentlyTime).dayName}، ${
            getPersianDateObj(currentlyTime).day
          } ${getPersianDateObj(currentlyTime).monthName}`
        : ""}
    </div>
  );
}

export default MessageDateCategories;
